module.exports = __webpack_public_path__ + "media/application/images/icons/add-circle-blue-b7d27282cbf83e700cd3e44ca8a31a70.svg";